import { environment } from 'src/environments/environment';

export class API {
  static HOST = environment.host;

  static readonly PAYMENT_SERVICE_HOST = environment.paymentServiceHost;

  static readonly AUTH_SERVICE_HOST = environment.authServiceHost;

  static CANCEL_URL = environment.cancelUrl;

  static APP = {
    cis: 'cis/',
    aip: 'aip/',
  };

  static routes = {
    ref: (reference: string) => `ref/${reference}`,
    initiatePaymentWithTransfer: 'initiatePaymentWithTransfer',
    initiatePaystackPayWithTransfer: 'payWithTempAccount',
    get_details_by_ref: 'ref/',
    payments: {
      instructions: (reference: string) => `instructions/${reference}`,
      updatePaymentMethod: (reference: string) => `initiate/${reference}`,
      status: (reference: string) => `status/${reference}`,
      session: (token: string) => `session/${token}`,
      payWithWallet: 'pay/wallet',
    },
    auth: {
      verifyHandshakeToken: (token: string) => `verify-handshake/${token}`,
    },
    meta: 'meta',
  };
}
